module.exports = __webpack_public_path__ + "img/Premium-Notebook.4eaf415.webp";